/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_contact_success_heading = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thanks for reaching out!`)
};

const es_contact_success_heading = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Gracias por escribirnos!`)
};

const de_contact_success_heading = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danke für deine Nachricht!`)
};

const nl_contact_success_heading = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bedankt voor je bericht!`)
};

const fr_contact_success_heading = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merci de nous avoir contactés !`)
};

const it_contact_success_heading = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grazie per averci contattato!`)
};

const pt_br2_contact_success_heading = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obrigado por entrar em contato!`)
};

const pt_contact_success_heading = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obrigado por entrares em contacto!`)
};

const ja_contact_success_heading = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お問い合わせありがとうございます！`)
};

const zh_contact_success_heading = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`感谢你的反馈！`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const contact_success_heading = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.contact_success_heading(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("contact_success_heading", locale)
	if (locale === "en") return en_contact_success_heading(inputs)
	if (locale === "es") return es_contact_success_heading(inputs)
	if (locale === "de") return de_contact_success_heading(inputs)
	if (locale === "nl") return nl_contact_success_heading(inputs)
	if (locale === "fr") return fr_contact_success_heading(inputs)
	if (locale === "it") return it_contact_success_heading(inputs)
	if (locale === "pt-BR") return pt_br2_contact_success_heading(inputs)
	if (locale === "pt") return pt_contact_success_heading(inputs)
	if (locale === "ja") return ja_contact_success_heading(inputs)
	return zh_contact_success_heading(inputs)
};